import React from "react";
import { motion } from "framer-motion";
import { FaCrown } from "react-icons/fa";

export default function PageName({ title, subTitle }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="mb-8 bg-[#121215]/90 backdrop-blur-xl p-6 rounded-2xl border border-[#C8A165]/20 shadow-2xl flex flex-col md:flex-row justify-between items-start md:items-center gap-4"
    >
      <div>
        <div className="flex items-center gap-3">
          <span className="p-2.5 bg-[#C8A165]/15 text-[#C8A165] border border-[#C8A165]/30 rounded-xl shadow-inner">
            <FaCrown size={15} />
          </span>
          <h2 className="text-2xl font-bold text-[#F8F5F2] tracking-tight">{title}</h2>
        </div>
        {subTitle && (
          <p className="mt-1 text-xs text-[#F8F5F2]/60 font-medium pl-11">{subTitle}</p>
        )}
      </div>

      <div className="flex items-center gap-2 text-xs font-medium text-[#F8F5F2]/40 bg-white/[0.03] px-3.5 py-1.5 rounded-full border border-white/5">
        <span>Admin Portal</span>
        <span>/</span>
        <span className="text-[#C8A165] font-semibold">{title}</span>
      </div>
    </motion.div>
  );
}
